import { ALL_INVITABLE_ROLES } from '../constants';
import { UserRowRoleType } from '../store/types';

export const getAllowedInviteRoles = (
  currentUserRole: UserRowRoleType,
): UserRowRoleType[] => {
  switch (currentUserRole) {
    case UserRowRoleType.Admin:
    case UserRowRoleType.SuperAdmin:
      return ALL_INVITABLE_ROLES;
    case UserRowRoleType.Editor:
    case UserRowRoleType.SuperEditor:
      return [
        UserRowRoleType.Editor,
        UserRowRoleType.Member,
        UserRowRoleType.Viewer,
      ];
    case UserRowRoleType.Member:
    case UserRowRoleType.SuperMember:
      return [UserRowRoleType.Member, UserRowRoleType.Viewer];
    case UserRowRoleType.Viewer:
    case UserRowRoleType.SuperViewer:
      return [UserRowRoleType.Viewer];
    default:
      return [];
  }
};
